import { BrowserRouter, HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DashLayout } from './components/dashlayout';
import { Dashboard } from './components/dashboard';
import { LoginPage } from './components/login';
import { Category } from './components/category';
import { Addproduct } from './components/products/addproduct';
import { Productlist } from './components/products/productlist';


function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginPage />} />
        <Route element={<DashLayout />}>
          <Route path="/superadmin/dashboard" element={<Dashboard />} />
          <Route path="/master/category" element={<Category />} />
          <Route path="/product/addproduct" element={<Addproduct />} />
          <Route path="/product/editproduct/:id" element={<Addproduct />} />
          <Route path="/product/:page" element={<Productlist />} />
        </Route>
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </HashRouter>
  );
}

export default App;
